<template>
  <h1 class="main-title">Limo Elderg</h1>
  <media-links-bar :socialMedias="socialMedias"></media-links-bar>
  <nav class="main-nav">
    <v-tabs
      class="tabs"
      align-tabs="center"
      show-arrows
      v-model="activeTab"
      @update:modelValue="onTabChange"
    >
      <v-tab :value="'sfw'">SFW</v-tab>
      <v-tab :value="'nsfw'">NSFW</v-tab>
      <v-tab :value="'stickers'">Stickers</v-tab>
      <v-tab :value="'anthro-sfw'">How to draw</v-tab>
    </v-tabs>
  </nav>
  <v-container><v-divider></v-divider></v-container>
  <router-view />
</template>

<script>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import MediaLinksBar from "./components/MediaLinksBar.vue";
import { socialMedia } from "./assets/social_media";

export default {
  components: { MediaLinksBar },
  data() {
    return {
      // Build new objects instead of mutating the social_media module, whose
      // base urls are read at import time by assets/artists.js
      socialMedias: {
        bsky: {
          ...socialMedia.bsky,
          url: socialMedia.bsky.url + "limoelderg.art",
        },
        furaffinity: {
          ...socialMedia.furaffinity,
          url: socialMedia.furaffinity.url + "limothedragon",
        },
      },
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    // Map every route to the tab that owns it. Several routes can share a tab,
    // so this cannot be inverted safely: see primaryRouteMap below.
    const tabMap = {
      "/": "sfw",
      "/nsfw": "nsfw",
      "/stickers": "stickers",
      "/references/anthro/sfw": "anthro-sfw",
      "/references/anthro/nsfw": "anthro-sfw",
      "/references/feral/sfw": "anthro-sfw",
      "/references/feral/nsfw": "anthro-sfw",
      "/commissions": "commissions",
    };

    // Map each tab to the route it should navigate to when clicked
    const primaryRouteMap = {
      sfw: "/",
      nsfw: "/nsfw",
      stickers: "/stickers",
      "anthro-sfw": "/references/anthro/sfw",
      commissions: "/commissions",
    };

    const activeTab = ref(tabMap[route.path] || "sfw");

    // Synchronize the active tab with the route change
    watch(
      () => route.path,
      (newPath) => {
        activeTab.value = tabMap[newPath] || "sfw";
        // The gallery filters are scoped to a single gallery, so clear them
        // whenever the visitor navigates elsewhere
        store.commit("resetFilters");
      }
    );

    // Change route on tab change
    function onTabChange(val) {
      const newRoute = primaryRouteMap[val];
      if (newRoute && newRoute !== route.path) {
        router.push(newRoute);
      }
    }

    return {
      activeTab,
      onTabChange,
    };
  },
};
</script>

<style lang="less" scoped>
@gold: #bfa181;
@turqoise: #178582;
@tab-default: #49627e;

.main-title {
  color: @gold;
  font-size: 120px;
  margin-top: 5%;
}

.main-nav {
  padding: 20px 0 10px;

  a {
    font-weight: bold;
    color: @tab-default;

    // Hovering a link that is not the current one paints it the colour of the
    // current one, the same as the tabs
    &:not(.router-link-exact-active):hover {
      color: @turqoise;
    }

    &.router-link-exact-active {
      color: @turqoise;
    }
  }
}

@media (max-width: 960px) {
  .main-title {
    color: @gold;
    font-size: 78px;
    margin-top: 5%;
  }
}
</style>